// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "imagemodal" + "." + "63b05fd00f8fc99ae5fb" + ".min.css";
};